// extracted by mini-css-extract-plugin
export var container = "events-section-module--container--2fAi9";
export var wrapper = "events-section-module--wrapper--2isDP";
export var events = "events-section-module--events--UR1oT";